// extracted by mini-css-extract-plugin
export default {"container":"style_container__3c43D","icon":"style_icon__8Afum"};